/**
 * 异常类型
 */
export var ErrorType;
(function (ErrorType) {
    /** 业务错误：http status =200 但是 retcode !== 0 */
    ErrorType["BUSINESS"] = "business";
    /** http status !== 200 */
    ErrorType["HTTP"] = "http";
})(ErrorType || (ErrorType = {}));
